import axios from "axios";

export const backendAxiosInstance = axios.create();
